export const TAGS_BATCH_SIZE = 25;

// Max product ids per Transparency Catalog /products request. Sending every id
// (e.g. 2000) in one call makes the URL/response too large and TC responds 502,
// so we split into chunks and fetch them in parallel waves.
export const EXTERNAL_PRODUCTS_CHUNK_SIZE = 100;

// How many Transparency Catalog chunk requests to run at once.
export const EXTERNAL_FETCH_CONCURRENCY = 4;